// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueScrollTo from 'vue-scrollto'
import _ from 'lodash'
import sassVars from './scss/_vars.scss'

import en from './locale/en'
import fr from './locale/fr'

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(VueYouTubeEmbed)
Vue.use(VueScrollTo)

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    en,
    fr
  }
})

/* eslint-disable no-new */
const root = new Vue({
  i18n,
  router,
  components: { App },
  template: '<App/>',
  metaInfo () {
    return {
      titleTemplate: this.$i18n.t('meta.titleTemplate'),
      htmlAttrs: {
        lang: this.$i18n.locale
      },
      meta: [
        { name: 'keywords', content: this.$i18n.t('meta.keywords') },
        { property: 'og:type', content: 'article' },
        { property: 'og:locale', content: this.$i18n.locale },
        { property: 'og:url', content: window.location.href },
        { property: 'og:title', content: this.$i18n.t('meta.shareTitle') },
        { property: 'og:description', content: this.$i18n.t('meta.shareDescription') }
      ]
    }
  },
  data: () => ({
    menuOpen: false,
    currentSubMenu: null,
    belowHero: false,
    shareOpen: false,
    modalOpen: false
  }),
  computed: {
    subMenuOpen () {
      return this.currentSubMenu !== null
    },
    sassVars () {
      return sassVars
    }
  },
  methods: {
    setLang () {
      if (this.$route.params.lang) {
        this.$i18n.locale = this.$route.params.lang
        // document.querySelector('html').setAttribute('lang', this.$i18n.locale)
      } else {
        console.log('No language found in the URL')
      }
    },
    calculateHeroScrollPosition () {
      // Find the first hero element on the page
      const $hero = document.querySelector('.se-hero')
      if ($hero) {
        // Find out where the bottom of the hero is
        const heroBottom = $hero.scrollTop + $hero.scrollHeight
        this.belowHero = window.pageYOffset > (heroBottom - 70)
      } else {
        this.belowHero = true // Always say we're below a hero if there's no hero on the page
      }
    }
  },
  mounted () {
    this.setLang()

    // Bind a throttled listener to the scroll event
    window.addEventListener('scroll', _.throttle(this.calculateHeroScrollPosition.bind(this), 100))

    // Fire it once for good measure
    this.calculateHeroScrollPosition()
  },
  watch: {
    '$route' (to, from) {
      this.setLang()
      // Only close the menu when the language hasn't changed
      if (to.params.lang === from.params.lang) {
        this.menuOpen = false
        this.currentSubMenu = null
      }
      this.modalOpen = false

      // Check the hero when we change routes (HACK!!!!)
      setTimeout(this.calculateHeroScrollPosition.bind(this), 500) // Need to find the proper lifecycle for this (it depends on the DOM)
    },
    menuOpen (value) {
      if (!value) {
        this.currentSubMenu = null
      }
    },
    modalOpen (value) {
      if (value) {
        document.body.classList.add('modalOpen')
      } else {
        document.body.classList.remove('modalOpen')
      }
    }
  }
})

document.addEventListener('DOMContentLoaded', function () {
  root.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/main.js